var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bbs_tit_g" }, [
    _c("div", { staticClass: "tit_info" }, [
      _c("strong", { staticClass: "tit_item" }, [
        _c("span", { staticClass: "search_query" }, [
          _vm._v("'" + _vm._s(_vm.query) + "'")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "result_txt" }, [_vm._v("검색결과")])
      ])
    ]),
    _vm._v(" "),
    _vm.showsDaumSearchLink
      ? _c("div", { staticClass: "extend_info" }, [
          _c(
            "a",
            {
              staticClass: "search_daum",
              attrs: {
                target: "_blank",
                rel: "noopener",
                href: _vm.daumSearchUrl
              }
            },
            [_vm._v("검색결과 더보기")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }